import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  TextField, InputAdornment, IconButton, Typography, List, ListItem, Box,
} from '@material-ui/core';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import {
  INPUT,
  UPLOAD_COMPANY_TAB,
  COUNT_DISP_STATUS,
  DATE_TIME_FORMAT,
} from '../../../common/const';
import {
  setSystemLodingFLg,
  setInitMessage,
  setErrorMessage,
} from '../../actions/CommonAction';
import {
  searchUploadJobList,
  setDispTab,
  setDispDate,
  filterJobList,
  setSelectSequenceId,
  setErrDispDate,
} from '../../actions/UploadAction';
import validator from '../../../common/validator';
import styles from './UploadJobListComponent.module.css';

class UploadJobListComponent extends Component {
  /**
   * コンポーネント初期表示字の処理
   */
  componentDidMount() {
    const { dispDate, setDispDateAct } = this.props;
    if (!dispDate) {
      // 表示日付が設定されていない場合、現在日付を設定
      setDispDateAct(moment().format(DATE_TIME_FORMAT.DATE));
    }
  }

  /**
   * 検索ボタン押下時の処理
   */
  onclickSearchButton = async () => {
    const {
      setDispTabAct,
      setSelectSequenceIdAct,
      setSystemLodingFLgAct,
      setInitMessageAct,
      setErrorMessageAct,
      searchUploadJobListAct,
      dispDate,
      setErrDispDateAct,
    } = this.props;

    // 選択中シーケンスIDを初期化
    setSelectSequenceIdAct(null);

    // メッセージエリア初期化
    setInitMessageAct();
    const msgs = [];
    // 日付の必須チェック
    validator.checkRequired(INPUT.UPLOAD.EXCUTION_DATE, dispDate, msgs);
    // 日付の妥当性チェック
    validator.checkIsDate(INPUT.UPLOAD.EXCUTION_DATE, dispDate, msgs);
    if (msgs.length !== 0) {
      setErrorMessageAct(msgs);
      setErrDispDateAct(true);
      return;
    }

    // 表示タブを「データ更新設定」に設定
    setDispTabAct(UPLOAD_COMPANY_TAB.SETTING);
    // エンターキー連打制御
    document.activeElement.blur();
    setErrDispDateAct(false);
    setSystemLodingFLgAct(true);
    // ジョブ一覧取得
    await searchUploadJobListAct(dispDate);
    setSystemLodingFLgAct(false);
  }

  /**
   * ジョブ一覧シーケンス押下
   * @param {*} sequenceId 押下されたシーケンスID
   */
  onclickJobListLink = (sequenceId) => {
    const {
      setSelectSequenceIdAct,
      filterJobListAct,
      setDispTabAct,
    } = this.props;

    // 選択シーケンスIDを設定
    setSelectSequenceIdAct(sequenceId);
    // ジョブ一覧から対象ジョブを抽出
    const ret = filterJobListAct();
    if (ret) {
      // 表示タブを「データ更新結果」に設定
      setDispTabAct(UPLOAD_COMPANY_TAB.RESULT);
    }
  }

  render() {
    const {
      selectSequenceId,
      jobList,
      dispDate,
      setDispDateAct,
      errDispDate,
    } = this.props;

    let list = <List className={`${styles.resultlistfield}`} />;

    if (jobList) {
      list = (
        <List className={`${styles.resultlistfield}`}>
          {jobList.map((result) => {
            // 作成日時
            const createTime = moment(
              result.create_datetime, DATE_TIME_FORMAT.DATE_TIME_FULL,
            ).format(DATE_TIME_FORMAT.TIME);
            // 読込件数
            // const readCount = '400/400件';
            const readCount = COUNT_DISP_STATUS.includes(result.status)
              && result.process_count !== undefined
              && result.process_count !== null
              && result.process_count !== ''
              && result.read_count !== undefined
              && result.read_count !== null
              && result.read_count !== ''
              && !Number.isNaN(Number(result.process_count))
              && !Number.isNaN(Number(result.read_count))
              ? `${Number(result.process_count).toLocaleString()}/${Number(result.read_count).toLocaleString()}件`
              : '';

            return (
              <ListItem
                key={result.seq_id}
                className={selectSequenceId === result.seq_id ? `${styles.row} ${styles.select}` : `${styles.row}`}
                onClick={() => this.onclickJobListLink(result.seq_id)}
              >
                <div className={`${styles.leftItem}`}>
                  <Typography className={`${styles.time}`}>{createTime}</Typography>
                </div>
                <div className={`${styles.centerItem}`}>
                  <Typography className={`${styles.filename}`}>{result.status_name}</Typography>
                </div>
                <div className={`${styles.rightItem}`}>
                  <Typography className={`${styles.readcount}`}>{readCount}</Typography>
                </div>
              </ListItem>
            );
          })}
        </List>
      );
    }

    return (
      <Box className={`${styles.uploadjoblist}`}>
        <Typography variant="subtitle1" component="div" className={`${styles.subtitleYearMonthDate}`}>年月日から検索</Typography>
        <TextField
          id="excutiondate"
          className={`${errDispDate ? styles.inputError : ''} `}
          variant="outlined"
          value={dispDate || ''}
          onChange={(ev) => setDispDateAct(ev.target.value)}
          onKeyDown={(ev) => {
            if (ev.key === 'Enter') {
              this.onclickSearchButton();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" className={`${styles.inputAdornment}`}>
                <IconButton
                  color="primary"
                  onClick={() => this.onclickSearchButton()}
                  className={`${styles.iconButton} ${styles.tooltip}`}
                >
                  <SearchIcon className={`${styles.searchIcon}`} />
                  <div className={`${styles.description}`}>検索</div>
                </IconButton>
              </InputAdornment>
            ),
            classes: {
              notchedOutline: errDispDate ? styles.notchedOutlineError : styles.notchedOutline,
            },
            className: styles.inputPropsYearMonthDate,
          }}
          size="small"
          error={errDispDate}
        />
        <div className="description">検索</div>
        {list}
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    selectSequenceId: state.upload.selectSequenceId,
    jobList: state.upload.jobList,
    dispDate: state.upload.dispDate,
    errDispDate: state.upload.errDispDate,
  }),
  (dispatch) => ({
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setErrorMessageAct: (errorMessage) => dispatch(setErrorMessage(errorMessage)),
    searchUploadJobListAct: (excutionDate) => dispatch(searchUploadJobList(excutionDate)),
    setDispTabAct: (str) => dispatch(setDispTab(str)),
    setDispDateAct: (dispDate) => dispatch(setDispDate(dispDate)),
    filterJobListAct: () => dispatch(filterJobList()),
    setSelectSequenceIdAct: (sequenceId) => dispatch(setSelectSequenceId(sequenceId)),
    setErrDispDateAct: (bool) => dispatch(setErrDispDate(bool)),
  }),
)(UploadJobListComponent);
